import environment from './src/environment';
import featureFlags from './src/featureFlags';
import sentry from './src/sentry';

export function onClientEntry() {
  sentry.init({environment});
  featureFlags.init({environment});
}
 